// Overrides for built-in fabric behaviors.
import { fabric } from 'fabric';
import ObjectBehaviors from './ObjectBehaviors';
import PathBehaviors from './PathBehaviors';
import { renderDragControl } from '../controls/controlRendering';
import { mixin } from '../utils/lang';
import SimpleGroup from './SimpleGroup';
import SimpleSelection from './SimpleSelection';
import UndoBehaviors from '../objects/UndoBehaviors';

let originalDragHandler;
function cancelableDragHandler(eventData, transform, x, y) {
  // Ignore very small drags that might happen when the user is just selecting
  // an object. We keep track of whether the drag started so that if the user
  // drags back to the same starting point it doesn't stick again. Note that
  // `transform` is recreated for each drag operation.
  if (
    !transform.dragAllowed &&
    Math.hypot(x - transform.lastX, y - transform.lastY) < 5
  ) {
    return false;
  } else {
    transform.dragAllowed = true;
  }

  // Don't allow dragging just a connector that has one end attached.
  if (transform.target.type === 'connector' && transform.target.attached()) {
    return false;
  }
  return originalDragHandler(eventData, transform, x, y);
}

function overrides() {
  mixin(fabric.Object.prototype, UndoBehaviors);
  mixin(fabric.Object.prototype, ObjectBehaviors);
  mixin(fabric.Path.prototype, PathBehaviors);

  // We completely reimplement groups - override the built-in group classes.
  // @ts-expect-error see Serialization.fromJSON
  fabric.Group = SimpleGroup;
  // @ts-expect-error see Serialization.fromJSON
  fabric.ActiveSelection = SimpleSelection;
  // @ts-expect-error Collection is missing from fabric types
  mixin(SimpleGroup.prototype, fabric.Collection);

  fabric.controlsUtils.renderCircleControl = renderDragControl;
  originalDragHandler = fabric.controlsUtils.dragHandler;
  fabric.controlsUtils.dragHandler = cancelableDragHandler;
}

export default overrides;
